import { ClientSelector } from '@gsgroup/gsgroup-react-ui';
import useLocales from '../../hooks/useLocales';
import { useOidcClientLogin } from '../../hooks/useOidcClientLogin';
import LoadingScreen from '../../components/commonComponents/LoadingScreen';

export default function AdminPage() {
    const { translate } = useLocales();
    const { existingClientId, handleSubmit } = useOidcClientLogin();

    // show LoadingScreen screen while we’re about to redirect
    if (existingClientId)
        return (
            <LoadingScreen />
        );

    // otherwise show Client id selector page
    return (
        <ClientSelector
            onSubmit={handleSubmit}
            submitText={translate('ClientSelector.Submit')}
            titleText={translate('ClientSelector.Title')}
            clientIdTextboxLabelText={translate('ClientSelector.ClientIdTextboxLabel')}
        />
    );
}